import Date                             from "../../../domain/fundamentals/date/Date";
import Time                             from "../../../domain/fundamentals/date/Time";
import FetchStatusRepository            from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import ReservationBusinessDayType       from "../../../domain/reservation/ReservationBusinessDayType";
import ReservationBusinessDayTypeClass  from "../../../domain/reservation/ReservationBusinessDayTypeClass";
import ReservationBusinessTime          from "../../../domain/reservation/ReservationBusinessTime";
import ReservationBusinessTimes         from "../../../domain/reservation/ReservationBusinessTimes";
import ReservationSetting               from "../../../domain/reservation/ReservationSetting";
import { ReservationSettingRepository } from "../../../domain/reservation/ReservationSettingRepository";
import ReservationSpecialBusinessTime   from "../../../domain/reservation/ReservationSpecialBusinessTime";
import ReservationSpecialBusinessTimes  from "../../../domain/reservation/ReservationSpecialBusinessTimes";
import ReservationTimeTypeClass         from "../../../domain/reservation/ReservationTimeTypeClass";
import ReservationWeekTypeClass         from "../../../domain/reservation/ReservationWeekTypeClass";
import FetchStatusDataSource            from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import ReservationSettingDataSource
                                        from "../../../infrastructure/datasource/reservation/ReservationSettingDataSource";

export default class GetReservationSetting {
  constructor(
    private readonly dispatch,
    private readonly repository: ReservationSettingRepository = new ReservationSettingDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
  ) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const response = await this.repository.get();
      const data = response.data;
      const businessTimes: ReservationBusinessTime[] = [];
      data.businessTimes.forEach(businessTime => {
        businessTimes.push(
          new ReservationBusinessTime(
            new ReservationWeekTypeClass(businessTime.weekType),
            new ReservationBusinessDayTypeClass(businessTime.regularHoliday === true ? ReservationBusinessDayType.REGULAR_HOLIDAY : ReservationBusinessDayType.BUSINESS_DAY),
            Time.ofText(businessTime.from),
            Time.ofText(businessTime.to)
          )
        );
      });

      const specialBusinessTimes: ReservationSpecialBusinessTime[] = [];
      data.specialBusinessTimes.forEach(specialBusinessTime => {
        specialBusinessTimes.push(
          new ReservationSpecialBusinessTime(
            new ReservationBusinessDayTypeClass(specialBusinessTime.holiday === true ? ReservationBusinessDayType.REGULAR_HOLIDAY : ReservationBusinessDayType.BUSINESS_DAY),
            Date.ofText(specialBusinessTime.date),
            Time.ofText(specialBusinessTime.from),
            Time.ofText(specialBusinessTime.to)
          )
        );
      });

      const reservationSetting: ReservationSetting = new ReservationSetting(
        new ReservationTimeTypeClass(data.displayTimeType),
        new ReservationBusinessTimes(businessTimes),
        new ReservationSpecialBusinessTimes(specialBusinessTimes)
      );

      this.repository.store(reservationSetting);
    } catch (e) {
    } finally {
      this.fetchStatusRepository.finish();
    }

  }
}
